import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { localStorageService } from '../../utils/storageUtils';
import { usePrevious } from '../../shared/hooks/usePrevious';
import type { Scenario } from '../../shared/queries/scenarios';
import { useCurrentClientId } from './utils';
import { setSelectedCompareScenario, setSelectedCurrency } from './store/actions';
import { selectedScenarioCurrencySelector, selectedScenarioToCompareSelector } from './store/selectors';
import initialState from './store/initialState';

type Nullable<T> = T | null;


type SavedOptions = {
  selectedScenarioToCompare: Nullable<number>,
  selectedCurrency: Nullable<string>,
}

export const useRestoreScenarioViewOptions = (
  scenarioId: Scenario['scenarioId']
) => {
  const dispatch = useDispatch();
  const clientId = useCurrentClientId();
  const storageKey = `scenario-options-${scenarioId}@client-${clientId}`;
  const previousStorageKey = usePrevious(storageKey);

  const selectedScenarioToCompare = useSelector(selectedScenarioToCompareSelector);
  const selectedCurrency = useSelector(selectedScenarioCurrencySelector);

  useEffect(() => {
    if (previousStorageKey === storageKey) {
      localStorageService.setItem(storageKey, { selectedScenarioToCompare, selectedCurrency });
    }
  }, [selectedScenarioToCompare, selectedCurrency, storageKey, previousStorageKey]);

  useEffect(() => {
    const options = localStorageService.getItem<SavedOptions>(storageKey, {
      selectedScenarioToCompare: initialState.selectedScenarioToCompare,
      selectedCurrency: initialState.selectedCurrency,
    }) as any;
    dispatch(setSelectedCurrency(options.selectedCurrency));
    dispatch(setSelectedCompareScenario(options.selectedScenarioToCompare));
  }, [scenarioId, storageKey, dispatch]);
};
